import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULTS = {
  hero: {
    eyebrow: "Bijuteria & Retrosaria",
    title_line1: "A elegância em",
    title_line2: "cada detalhe.",
    description: "Peças cuidadosamente selecionadas. Materiais nobres. Acabamentos artesanais.",
    image_url: "",
    cta_primary: "Explorar coleção",
    cta_secondary: "A nossa história",
  },
  benefits: [],
  categories_section: {
    eyebrow: "Categorias",
    title: "Explore o nosso universo",
    bijuteria_title: "Bijuteria",
    bijuteria_image: "",
    retrosaria_title: "Retrosaria",
    retrosaria_image: "",
  },
  featured_section: { eyebrow: "Destaques", title: "Em destaque" },
  editorial_cta: { eyebrow: "", title: "", description: "", cta_text: "" },
  nav_menu: [
    { label: "Início", path: "/" },
    { label: "Loja", path: "/loja" },
    { label: "Sobre", path: "/sobre" },
  ],
};

const ContentContext = createContext({ content: DEFAULTS, loading: true, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/content");
      setContent({ ...DEFAULTS, ...data });
    } catch {
      setContent(DEFAULTS);
    } finally { setLoading(false); }
  };

  useEffect(() => { refresh(); }, []);

  return <ContentContext.Provider value={{ content, loading, refresh }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
